import { likeProduct, unlikeProduct } from '../services/productService'; // Import API service functions

export const handleLikeClick = async ({
    productId,
    isLikedByUser,
    loggedInUser,
    setLikedProducts,
    setProducts,
    navigate,
    setNotification,
    redirectToLogin,
}) => {
    if (!loggedInUser) {
        if (redirectToLogin) {
            redirectToLogin(window.location.pathname);
        } else {
            navigate('/login'); // Fallback to navigate if redirectToLogin not provided
        }
        return;
    }

    // Get the product from the current state
    let currentProduct = null;
    setProducts((prev) => {
        currentProduct = prev.find((p) => p.id === productId);
        return prev; // Return the unchanged state
    });

    // Prevent the logged-in user from liking their own product
    if (currentProduct && currentProduct.owner === loggedInUser.id) {
        setNotification({
            message: 'Vous ne pouvez pas aimer vos propres produits.',
            type: 'info', // Changed to 'info' for informational notification
            header: 'Action non autorisée',
        });
        return;
    }

    // Track the current state
    const currentState = {
        isLiked: isLikedByUser,
        likes: currentProduct ? currentProduct.likes : 0,
    };

    // Immediately update the UI for better UX
    const updateLocalState = (liked, serverResponse = null) => {
        // Update liked products state
        setLikedProducts((prev) => {
            const newState = liked
                ? [...new Set([...prev, productId])]
                : prev.filter((id) => id !== productId);
            return newState;
        });

        // Update products state
        setProducts((prev) => {
            if (!Array.isArray(prev)) {
                console.error('Expected products to be an array, got:', prev);
                return prev;
            }

            return prev.map((product) => {
                if (product.id === productId) {
                    return {
                        ...product,
                        // Use server response likes if available, otherwise calculate locally
                        likes: serverResponse?.likes !== undefined
                            ? serverResponse.likes
                            : Math.max(0, product.likes + (liked ? 1 : -1)),
                        liked_by: liked
                            ? [...new Set([...(product.liked_by || []), loggedInUser.id])]
                            : (product.liked_by || []).filter((id) => id !== loggedInUser.id),
                    };
                }
                return product;
            });
        });
    };

    try {
        // Optimistically update the UI
        updateLocalState(!isLikedByUser);

        // Make the API call
        const response = await (isLikedByUser ? unlikeProduct(productId) : likeProduct(productId));

        if (response.error) {
            throw new Error(response.error);
        }

        // Update the products state with the server response
        if (response.likes !== undefined) {
            setProducts((prev) => {
                if (!Array.isArray(prev)) {
                    console.error('Expected products to be an array, got:', prev);
                    return prev;
                }

                return prev.map((product) =>
                    product.id === productId
                        ? { 
                            ...product, 
                            likes: response.likes,
                            liked_by: response.liked_by || product.liked_by || []
                          }
                        : product
                );
            });
        }

        // Show success notification
        setNotification({
            message: isLikedByUser
                ? 'Produit retiré des favoris'
                : 'Produit ajouté aux favoris',
            type: 'success',
            header: 'Succès',
        });
    } catch (error) {
        console.error('Error handling like:', error);

        // Revert the UI state in case of an error
        updateLocalState(isLikedByUser);

        // Show error notification
        setNotification({
            message: error.message || 'Une erreur est survenue lors de l\'action',
            type: 'error',
            header: 'Erreur',
        });
    }
};